// @flow
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef } from "react";
import InfoMessage from "./../InfoMessage/InfoMessage";
import "./input.scss";

type Props = {
    className?: string,
    placeholder?: string,
    onChange: Function,
    variant?: string,
    value?: string,
    type?: string,
    title?: any,
    required?: boolean,
    name?: string,
    props?: Object,
    feedbackMessage?: string,
    isInvalid?: boolean,
    hasEye?: boolean,
    infoMessage?: any,
    onFocus?: Function,
    onFocusOut?: Function,
    autoFocus?: Boolean,
    checkbox?: Boolean,
    hasOther?: Boolean,
};

export default function Input({
    className = "",
    checkbox = false,
    placeholder,
    autoFocus = false,
    onChange,
    variant = "border-light",
    value,
    type,
    title,
    isRequired,
    name = "",
    feedbackMessage,
    isInvalid,
    hasEye,
    onFocus,
    infoMessage,
    onFocusOut,
    hasOther,
    ...props
}: Props): React$Element<any> {
    const ref = useRef(null);

    useEffect(() => {
        if (ref?.current) {
            ref.current.value = value || null;
        }
    }, [value]);

    const handleWheel = (event) => {
        event.target.blur();
    };

    return (
        <div
            controlId={name}
            className={`${"custom-input was-validated"} ${
                isInvalid ? "input-error" : ""
            } ${className}`}
        >
            {title && <label>{title}</label>}
            {infoMessage && !value && <InfoMessage text={infoMessage} />}
            <input
                {...props}
                className={`form-control shadow-none ${
                    isInvalid ? "is-invalid" : ""
                } ${variant} ${hasOther ? "has-other" : ""}`}
                autoFocus={autoFocus}
                type={hasEye && type === "password" ? "password" : type}
                name={name}
                ref={ref}
                value={value}
                required={isRequired}
                placeholder={placeholder}
                onChange={onChange}
                onBlur={onFocusOut}
                onFocus={onFocus}
                onWheel={handleWheel}
                maxLength="100"
            />
            {!checkbox && value && !isInvalid && (
                <FontAwesomeIcon className="check-icon" icon={faCheckCircle} />
            )}
            {feedbackMessage && (
                <div
                    className={
                        isInvalid
                            ? "invalid-feedback"
                            : "valid-feedback"
                    }
                >
                    {feedbackMessage}
                </div>
            )}
        </div>
    );
}
